// Play animation timing constants
export const PLAY_TIMING = {
  deadHoldMs: 1000,
  huddleRunMs: 800,
  breakHuddleMs: 700,
  preSnapHoldMs: 1400,
  scrimmageChangeoverMs: 900,
  specialTeamsExitMs: 700,
  specialTeamsEnterMs: 800,
  specialTeamsSetMs: 700,
  livePlayMs: 2200,
  resultFadeMs: 2500,
} as const;

export const HALFTIME_TOTAL_MS = 120_000;

export const INTERMISSION_TIMING = {
  settleMs: 1000,
  quarterBreakSettleMs: 1000,
  runoffMs: 1200,
  cameraPanMs: 950,
  quarterBreakHoldMs: 5000,
  // The runoff, settle, camera pan, and hold add up to exactly two minutes.
  // Owners get the first minute; the authoritative Q3 package gets the second.
  halftimeHoldMs: HALFTIME_TOTAL_MS - 1000 - 1200 - 950,
  finalHoldMs: 3600,
  finalOverlayFadeMs: 900,
} as const;

export const REPLAY_HOLD_MS = 3000;
export const LIVE_FRAME_MS = 1000 / 30;
export const LIVE_SEQUENCE_VERSION = 'pursuit-model-v1';
